import { useEffect, useRef } from "react";

export default function CanvasMountains() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = window.innerHeight);

    ctx.clearRect(0, 0, width, height);

    // Draw mountains
    ctx.fillStyle = "#6B7280"; // Tailwind gray-500
    ctx.beginPath();
    ctx.moveTo(0, height);
    ctx.lineTo(width * 0.25, height * 0.5);
    ctx.lineTo(width * 0.5, height);
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(width * 0.5, height);
    ctx.lineTo(width * 0.75, height * 0.4);
    ctx.lineTo(width, height);
    ctx.fill();}
  )
  return (
    <canvas
      ref={canvasRef}
      className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
    />
  );
}
